var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Stack', {
    staticClass: "gap-2"
  }, [_c('HStack', {
    staticClass: "gap-2"
  }, [_c('b-input-group', {
    staticClass: "input-group-merge flex-1"
  }, [_c('BFormInput', {
    staticClass: "form-control-merge",
    attrs: {
      "debounce": "300",
      "placeholder": _vm.$t('myAccount.systemConfigs.errorMessages.searchTextPlaceholder')
    },
    model: {
      value: _vm.searchText,
      callback: function callback($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('b-input-group-append', {
    attrs: {
      "is-text": ""
    }
  }, [_c('BButton', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.searchText,
      expression: "searchText"
    }],
    staticClass: "btn-icon p-25",
    attrs: {
      "variant": "flat-danger",
      "size": "sm"
    },
    on: {
      "click": function click($event) {
        _vm.searchText = '';
      }
    }
  }, [_c('IAmIcon', {
    attrs: {
      "icon": "closeOutline"
    }
  })], 1)], 1)], 1), _c('div', [_c('BButton', {
    staticClass: "px-75",
    attrs: {
      "variant": "info"
    },
    on: {
      "click": function click() {
        return _vm.$bvModal.show('modal-input-error-messages');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('ticket.addOrEdit')) + " ")])], 1)], 1), _c('BTable', {
    ref: "errorMessagesTableRef",
    staticClass: "mb-0",
    style: {
      maxHeight: _vm.tableHeight
    },
    attrs: {
      "items": _vm.errorListRender,
      "no-border-collapse": "",
      "sticky-header": "",
      "fields": _vm.columns,
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "responsive": "",
      "show-empty": "",
      "empty-text": _vm.searchText ? _vm.$t('myAccount.systemConfigs.errorMessages.searchEmptyData') : _vm.$t('myAccount.systemConfigs.errorMessages.emptyData')
    },
    scopedSlots: _vm._u([{
      key: "cell(index)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.index + 1) + " ")];
      }
    }, {
      key: "cell(key)",
      fn: function fn(data) {
        return [_c('HStack', {
          staticClass: "hover-div"
        }, [_c('pre', {
          staticClass: "text-wrap mb-0 text-dark fw-700"
        }, [_vm._v(_vm._s(data.item.key))]), _c('IAmCopyTextButton', {
          attrs: {
            "text": data.item.key
          }
        })], 1)];
      }
    }, {
      key: "cell(viValue)",
      fn: function fn(data) {
        return [_c('HStack', {
          staticClass: "hover-div"
        }, [_vm._v(" " + _vm._s(data.item.viValue) + " "), _c('IAmCopyTextButton', {
          attrs: {
            "text": data.item.viValue
          }
        })], 1)];
      }
    }, {
      key: "cell(value)",
      fn: function fn(data) {
        return [_c('HStack', {
          staticClass: "hover-div"
        }, [_vm._v(" " + _vm._s(data.item.value) + " "), _c('IAmCopyTextButton', {
          attrs: {
            "text": data.item.value
          }
        })], 1)];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('HStack', {
          attrs: {
            "center": ""
          }
        }, [_c('BButton', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.left.window.hover",
            value: _vm.$t('ticket.selectToAddOrEditList'),
            expression: "$t('ticket.selectToAddOrEditList')",
            modifiers: {
              "left": true,
              "window": true,
              "hover": true
            }
          }],
          staticClass: "rounded p-50",
          attrs: {
            "variant": !_vm.errorMessagesToEdit.some(function (i) {
              return i.key === data.item.key;
            }) ? 'flat-info' : 'flat-success',
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.onClickEdit(data.item);
            }
          }
        }, [!_vm.errorMessagesToEdit.some(function (i) {
          return i.key === data.item.key;
        }) ? _c('IAmIcon', {
          attrs: {
            "icon": "pencil",
            "size": "14"
          }
        }) : _c('IAmIcon', {
          attrs: {
            "icon": "tick",
            "size": "14"
          }
        })], 1)], 1)];
      }
    }])
  }), _c('ModalInputErrorMessages', {
    attrs: {
      "columns": _vm.columns,
      "errorList": _vm.errorMessagesToEdit
    },
    on: {
      "clearErrorList": function clearErrorList($event) {
        _vm.errorMessagesToEdit = [];
      }
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }